import WonderType from '@/roc/wonders/base/WonderType';
import WonderKind from '@/roc/wonders/base/WonderKind';
import WonderOwner from '@/roc/wonders/base/WonderOwner';
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const CityOfBrass = {
  id: '135',
  name: 'City of Brass',
  era: EraType.earlyRome,
  icon: 'brass',
  gameId: 'CityOfBrass',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.ARABIA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.CAVALRY_HIT_RATE_MOD,
      EffectAmount.asPerLevel([
        25,
        35,
        43,
        49,
        54,   // 5
        59,
        64,
        68,
        72,
        75,   // 10
        79,
        82,
        85,
        88,
        91,   // 15
        94,
        96,
        99,
        101,
        104,  // 20
        106,
        108,
        111,
        113,
        115,  // 25
        117,
        119,
        121,
        123,
        125   // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.ARABIAN_BAZAAR_OFFERS_MOD,
      EffectAmount.asPerLevel([
        15,
        21,
        25,
        29,
        31,   // 5
        34,
        36,
        38,
        39,
        41,   // 10
        42,
        43,
        44,
        45,
        46,   // 15
        47,
        48,
        49,
        50,
        51,   // 20
        52,
        53,
        54,
        55,
        56,   // 25
        57,
        58,
        59,
        60,
        60    // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.CAVALRY_MOVEMENT_SPEED_MOD,
      EffectAmount.asFlat(0),
      '%',
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(10).withKind(WonderKind.PALACE),
      effect: null,
    },
    {
      effectIndex: 2,
      mod: Synergy.asFlat(10).withKind(WonderKind.PALACE),
      effect: null,
    },
  ],
};

export default CityOfBrass;
